import { config as configDev } from './config.dev'
import { config as configProd } from './config.prod'

export * from './endpoints'

export const config = process.env.NODE_ENV === 'production' ? configProd : configDev


// WEBPACK FOOTER //
// ./src/config/index.ts